module.exports = __webpack_public_path__ + "static/media/photo-6-m.7000757b.jpeg";